import React, { Fragment, useMemo, useState } from 'react';
import { observer } from 'mobx-react';
// services
import LocaleService from 'modules/Localization';
import AnalyticsService from 'modules/Analytics';
// import { LStorage } from 'modules/Storage';
import PositionService from 'modules/TradesPW3/Positions';
// store
import { useStore } from 'modules/Stores';
// constants
import { EVENTS } from 'modules/Analytics/consts';
// utils
import { getBasketOrderChargesRequestData } from 'modules/TradesPW3/utils';
import { extractOpenPositionInstruments, getNonDeliveryPositions, getSurveillanceShownMap } from 'modules/TradesPW3/Positions/utils';
// components
import { Button, View } from '@upstox/upstox-ui';
import Modal from 'app/components/MainLayout/components/Modal';
import { PreRiskData } from 'modules/PreRisk/typings';
import SquareOffPreRiskWarning from '../SurveillanceMessages/SurveillanceMessages';
import EstimatedCharges from '../EstimatedCharges/EstimatedCharges';
// styles
import * as css from './styles';
// utils
import { getScripsForSurveillanceEvent } from './utils';
import { addSurveillanceEvent } from '../SurveillanceMessages/utils';

const PositionsMtmExitAllModal = () => {
  const {
    toggleModal,
    modalsConfig: { positionsMtmExitAllModal },
  } = useStore('AppStore');
  const { groupedPositionsByType } = useStore('PositionsPW3Service');
  const positionsToExit =
    getNonDeliveryPositions(groupedPositionsByType.openPositions);
  const openPositionsQty = positionsToExit.length;
  const [surveillanceData, setSurveillanceData] = useState<PreRiskData[]>([]);
  // const [isDoNotShowAgain, setDoNotShowAgain] = useState(false);

  const isSurveillanceShownMap = useMemo(
    () => getSurveillanceShownMap(surveillanceData),
    [surveillanceData],
  );

  const onClose = async () => {
    AnalyticsService.sendEvent(
      EVENTS.POSITIONS_MTM_EXIT_ALL_CANCELLED,
    );
    const surveillanceInstrumentKeys = Object.keys(isSurveillanceShownMap);
    if (surveillanceInstrumentKeys?.length > 0) {
      const scrips = await getScripsForSurveillanceEvent(
        surveillanceInstrumentKeys,
      );
      addSurveillanceEvent('Cancel', 'Multi position square off', scrips);
    }
    toggleModal('positionsMtmExitAllModal');
  };

  const handleSubmit = async () => {
    AnalyticsService.sendEvent(EVENTS.POSITIONS_MTM_EXIT_ALL_EXECUTED);
    PositionService.multiPositionSquareOff(
      positionsToExit,
      isSurveillanceShownMap,
    );
    const surveillanceInstrumentKeys = Object.keys(isSurveillanceShownMap);
    if (surveillanceInstrumentKeys?.length > 0) {
      const scrips = await getScripsForSurveillanceEvent(
        surveillanceInstrumentKeys,
      );
      addSurveillanceEvent('Yes', 'Multi position square off', scrips);
    }
    toggleModal('positionsMtmExitAllModal');
  };

  // To be added in future to support do not show again
  // const handleDoNotShowAgain = () => {
  //   LStorage.setItem('DO_NOT_SHOW_POSITIONS_MTM_MODAL', (!isDoNotShowAgain).toString());
  //   setDoNotShowAgain(!isDoNotShowAgain);
  // };

  const basketOrderData =
    getBasketOrderChargesRequestData(positionsToExit);
  const openPositionInstruments =
    extractOpenPositionInstruments(positionsToExit);

  return positionsMtmExitAllModal ? (
    <Modal
      onClose={onClose}
      title={LocaleService.translate('POSITIONS_MTM_EXIT_ALL_MODAL_TITLE', openPositionsQty.toString())}
      styles={css.modalContainer}
    >
      <View
        as="div"
        css={css.contentContainer}
      >
        <View css={css.description}>
          {LocaleService.translate('POSITIONS_MTM_MODAL_DISCLAIMER')}
        </View>
        <SquareOffPreRiskWarning
          basketOrderInstrumentKeys={openPositionInstruments}
          setSurveillanceData={setSurveillanceData}
        />
        <EstimatedCharges
          basketOrderData={basketOrderData}
        />
        {/* To be added in future to support do not show again */}
        {/* <View
          css={css.checkboxContainer}
        >
          <Checkbox
            readOnly
            onChange={handleDoNotShowAgain}
            isSquare
            className="checkboxIcon"
          />
          <Text size="s">{LocaleService.translate('DONT_SHOW_AGAIN')}</Text>
        </View> */}
        <View
          as="div"
          css={css.buttonContainer}
        >
          <Button
            onClick={onClose}
            size="small"
            style={css.button}
            variant="secondary"
            autoFocus
          >
            {LocaleService.translate('CANCEL_BUTTON')}
          </Button>
          <Button
            onClick={handleSubmit}
            size="small"
            style={css.button}
            variant="primary"
          >
            {LocaleService.translate('YES')}
          </Button>
        </View>
      </View>
    </Modal>
  ) : (
    <Fragment />
  );
};

export default observer(PositionsMtmExitAllModal);
